import React, { useEffect, useRef } from 'react';
import TimePicker from 'react-time-picker';

import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

import { inputBaseClasses } from '../TextField';

type TimePickerPropType = {
  value: any;
  onChange: (e: any) => void;
};

function ReactTimePicker({ value, onChange }: TimePickerPropType) {
  const pickerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (pickerRef.current) {
      const inputs = pickerRef.current.querySelectorAll('input');
      // to limit to two digits
      inputs.forEach(input => {
        input.setAttribute('maxLength', '2');
        input.addEventListener('input', () => {
          if (input.value.length > 2) {
            input.value = input.value.slice(0, 2);
          }
        });
      });
    }
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    if (!target) return;

    let allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Delete',
    ];

    // check if it is the am/pm field
    if (target.placeholder !== 'hh' && target.placeholder !== 'mm') {
      allowedKeys = [...allowedKeys, 'a', 'p', 'A', 'P'];
    }

    const isNumber = /^[0-9]$/.test(e.key);

    if (!isNumber && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div ref={pickerRef}>
      <TimePicker
        value={value}
        onChange={onChange}
        format="hh:mm a"
        hourPlaceholder="hh"
        minutePlaceholder="mm"
        disableClock={true}
        className={inputBaseClasses}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}

export { ReactTimePicker };
